// Layouts
import Layout from '../components/Layout/Layout';
import Story from '../components/Story/Story';

// Components
import AccordionCard from '../sections/AccordionSection/components/AccordionCard/AccordionCard';
import BoxCard from '../sections/BoxCardsSection/components/BoxCard/BoxCard';
import Button from '../components/Button/Button';
import CarouselSlide from '../components/CarouselSlide/CarouselSlide';
import FeaturedCompanySlide from '../components/FeaturedCompanySlide/FeaturedCompanySlide';
import FeaturedNewsCard from '../components/FeaturedNewsCard/FeaturedNewsCard';
import Image from '../components/ImageComponent/ImageComponent';
import IconButton from '../components/IconButton/IconButton';
import LayoutSlot from '../components/LayoutSlot/LayoutSlot';
import MarkupContent from '../components/MarkupContent/MarkupContent';
import NewsArticleCard from '../components/NewsArticleCard/NewsArticleCard';
import StatsCard from '../sections/StatsSection/components/StatsCard/StatsCard';
import TeamMemberCard from '../components/TeamMemberCard/TeamMemberCard';

// Sections
import BlockquoteSection from '../old-sections/BlockquoteSection/BlockquoteSection';
import CarouselSection from '../old-sections/CarouselSection/CarouselSection';
import CentredTextSection from '../old-sections/CentredTextSection/CentredTextSection';
import NewFilterSection from '../sections/FilterSection/FilterSection';
import HeaderHeroImageSection from '../old-sections/HeaderHeroImageSection/HeaderHeroImageSection';
import JobsSection from '../old-sections/JobsSection/JobsSection';
import LayoutSection from '../old-sections/LayoutSection/LayoutSection';
import ManualNewsSection from '../sections/ManualNewsSection/ManualNewsSection';
import NewsItemFootnoteSection from '../old-sections/NewsItemFootnoteSection/NewsItemFootnoteSection';
import NewsItemHeaderSection from '../old-sections/NewsItemHeaderSection/NewsItemHeaderSection';
import NewsSection from '../old-sections/NewsSection/NewsSection';
import NewsSummarySection from '../old-sections/NewsSummarySection/NewsSummarySection';
import PortfolioSectorSection from '../old-sections/PortfolioSectorSection/PortfolioSectorSection';
import NewTeamSection from '../sections/TeamSection/TeamSection';
import TeamMemberSummarySection from '../old-sections/TeamMemberSummarySection/TeamMemberSummarySection';
import TextSection from '../old-sections/TextSection/TextSection';
import TwoToneCarouselSection from '../old-sections/TwoToneCarouselSection/TwoToneCarouselSection';

import AccordionSection from '../sections/AccordionSection/AccordionSection';
import BoxCardsSection from '../sections/BoxCardsSection/BoxCardsSection';
import PortfolioCarouselSection from '../sections/PortfolioCarouselSection/PortfolioCarouselSection';
import FeaturedCompaniesGridSection from '../sections/FeaturedCompaniesGridSection/FeaturedCompaniesGridSection';
import HeaderAndIconsSection from '../sections/HeaderAndIconsSection/HeaderAndIconsSection';
import HeaderHeroSection from '../sections/HeaderHeroSection/HeaderHeroSection';
import IconQuadSection from '../sections/IconQuadSection/IconQuadSection';
import ImageAndTextGridBuilderSection from '../sections/ImageAndTextGridBuilderSection/ImageAndTextGridBuilderSection';
import ImageWithTextSection from '../sections/ImageWithTextSection/ImageWithTextSection';
import InsetImageGridSection from '../sections/InsetImageGridSection/InsetImageGridSection';
import SpacerSection from '../sections/SpacerSection/SpacerSection';
import GlobalCTASection from '../sections/GlobalCTASection/GlobalCTASection';
import MacroDirectorySection from '../sections/MacroDirectorySection/MacroDirectorySection';
import MacroIconCarouselSection from '../sections/MacroIconCarouselSection/MacroIconCarouselSection';
import StatsSection from '../sections/StatsSection/StatsSection';
import PortfolioCardsSection from '../sections/PortfolioCardsSection/PortfolioCardsSection';
import SimpleHeaderAndTextTwoColSection from '../sections/SimpleHeaderAndTextTwoColSection/SimpleHeaderAndTextTwoColSection';
import TabCarouselSection from '../sections/TabCarouselSection/TabCarouselSection';
import TeamGridSection from '../sections/TeamGridSection/TeamGridSection';
import TitleAndBulletsSection from '../sections/TitleAndBulletsSection/TitleAndBulletsSection';
import TwoBoxCardsSection from '../sections/TwoBoxCardsSection/TwoBoxCardsSection';
import TwoColumnTilesSection from '../sections/TwoColumnTilesSection/TwoColumnTilesSection';
import CompanyIntroSection from '../sections/CompanyIntroSection/CompanyIntroSection';
import ContentCarouselSection from '../sections/ContentCarouselSection/ContentCarouselSection';
import HeaderAndSubheadSection from '../sections/HeaderAndSubheadSection/HeaderAndSubheadSection';
import InsightsGridSection from '../sections/InsightsGridSection/InsightsGridSection';
import ThreeColumnsCompaniesGridSection from '../sections/ThreeColumnsCompaniesGridSection/ThreeColumnsCompaniesGridSection';

import PortfolioCarouselCard from '../sections/PortfolioCarouselSection/components/PortfolioCarouselCard/PortfolioCarouselCard';
import FeaturedCompaniesGridCard from '../sections/FeaturedCompaniesGridSection/components/FeaturedCompaniesGridCard/FeaturedCompaniesGridCard';
import HeaderAndIconsCard from '../sections/HeaderAndIconsSection/components/HeaderAndIconsCard/HeaderAndIconsCard';
import IconQuadCard from '../sections/IconQuadSection/components/IconQuadCard/IconQuadCard';
import ImageAndTextGridBuilderCard from '../sections/ImageAndTextGridBuilderSection/components/ImageAndTextGridBuilderCard/ImageAndTextGridBuilderCard';
import InsetImageGridCard from '../sections/InsetImageGridSection/components/InsetImageGridCard/InsetImageGridCard';
import ContentCarouselCard from '../sections/ContentCarouselSection/components/ContentCarouselCard/ContentCarouselCard';
import InsightsGridCard from '../sections/InsightsGridSection/components/InsightsGridCard/InsightsGridCard';
import MacroIconCarouselCard from '../sections/MacroIconCarouselSection/components/MacroIconCarouselCard/MacroIconCarouselCard';
import TitleAndBulletsCard from '../sections/TitleAndBulletsSection/components/TitleAndBulletsCard/TitleAndBulletsCard';
import TabCarouselCard from '../sections/TabCarouselSection/TabCarouselContent/Desktop/components/TabCarouselCard/TabCarouselCard';
import TabCarouselCardLogo from '../sections/TabCarouselSection/TabCarouselContent/Desktop/components/TabCarouselCardLogo/TabCarouselCardLogo';
import ThreeColumnsCompaniesGridCard from '../sections/ThreeColumnsCompaniesGridSection/components/ThreeColumnsCompaniesGridCard/ThreeColumnsCompaniesGridCard';
import { CompanyIntroStatCard } from '../sections/CompanyIntroSection/components/CompanyIntroStatCard/CompanyIntroStatCard';
import CompanyIntroLogoCard from '../sections/CompanyIntroSection/components/CompanyIntroLogoCard/CompanyIntroLogoCard';
import { TwoBoxCardsCard } from '../sections/TwoBoxCardsSection/components/TwoBoxCardsCard/TwoBoxCardsCard';
import MacroDirectoryCard from '../sections/MacroDirectorySection/components/MacroDirectoryCard/MacroDirectoryCard';
import PageBreak from '../sections/PageBreak/PageBreak';
import BackgroundSection from '../sections/BackgroundSection/BackgroundSection';
import LargeBoxCardsSection from '../sections/LargeBoxCardsSection/LargeBoxCardsSection';
import LargeBoxCard from '../sections/LargeBoxCardsSection/components/LargeBoxCard/LargeBoxCard';
import HeaderNavLinksList from '../navigation/Header/components/HeaderNavLinksList/HeaderNavLinksList';
import HeaderNavLink from '../navigation/Header/components/HeaderNavLink/HeaderNavLink';

import StoryblokDefault from './StoryblokDefault';
import StoryblokPage from './StoryblokPage';

export const ComponentList = {
  // Meta
  page: StoryblokPage,
  layout: Layout,
  // Components
  AccordionCard,
  BoxCard,
  Button,
  CarouselSlide,
  PortfolioCarouselCard,
  FeaturedCompaniesGridCard,
  FeaturedCompanySlide,
  FeaturedNewsCard,
  HeaderAndIconsCard,
  Image,
  IconButton,
  IconQuadCard,
  ImageAndTextGridBuilderCard,
  InsetImageGridCard,
  ContentCarouselCard,
  InsightsGridCard,
  LayoutSlot,
  MarkupContent,
  MacroIconCarouselCard,
  StatsCard,
  TeamMemberCard,
  TwoBoxCardsCard,
  TitleAndBulletsCard,
  TabCarouselCard,
  ThreeColumnsCompaniesGridCard,
  CompanyIntroStatCard,
  CompanyIntroLogoCard,
  // Sections
  AccordionSection,
  BlockquoteSection,
  BoxCardsSection,
  CarouselSection,
  CentredTextSection,
  PortfolioCarouselSection,
  FeaturedCompaniesGridSection,
  NewFilterSection,
  HeaderAndIconsSection,
  HeaderAndSubheadSection,
  HeaderHeroSection,
  HeaderHeroImageSection,
  IconQuadSection,
  ImageWithTextSection,
  ImageAndTextGridBuilderSection,
  InsetImageGridSection,
  ContentCarouselSection,
  InsightsGridSection,
  JobsSection,
  LayoutSection,
  GlobalCTASection,
  ManualNewsSection,
  MacroDirectorySection,
  MacroIconCarouselSection,
  StatsSection,
  NewsArticleCard,
  NewsItemFootnoteSection,
  NewsItemHeaderSection,
  NewsSection,
  NewsSummarySection,
  PortfolioCardsSection,
  PortfolioSectorSection,
  SimpleHeaderAndTextTwoColSection,
  SpacerSection,
  TabCarouselSection,
  TeamGridSection,
  NewTeamSection,
  TeamMemberSummarySection,
  TextSection,
  ThreeColumnsCompaniesGridSection,
  TitleAndBulletsSection,
  TwoBoxCardsSection,
  TwoColumnTilesSection,
  TwoToneCarouselSection,
  CompanyIntroSection,
  MacroDirectoryCard,
  PageBreak,
  TabCarouselCardLogo,
  LargeBoxCardsSection,
  LargeBoxCard,
  BackgroundSection,
  HeaderNavLinksList,
  HeaderNavLink,
};

const StoryComponent = Story(ComponentList);

const Components = (type: string) => {
  if (type === 'Story') {
    return StoryComponent;
  }
  if (typeof ComponentList[type] === 'undefined') {
    return StoryblokDefault;
  }
  return ComponentList[type];
};

export default Components;
